import enEU from './en-eu.json';
import daDK from './da-dk.json';

const translations = { 'en-eu': enEU, 'da-dk': daDK };

const getTranslations = (langCode) => translations[langCode] || translations['da-dk'];

export default getTranslations;